import { errorToast } from "@/ui/toast/Toast";
import i18n from "@/i18n";
import { createPaymentMethodSession } from "../api";
import { useApiSend } from "@/hooks/useApi";

// Sends the user to a Stripe-hosted card form. Stripe handles 3DS there, and
// the webhook adopts the new card and retries the stalled renewal on the way
// back, so there is nothing to do here beyond the redirect.
export function useUpdatePaymentMethod() {
	const { mutateAsync, isPending } = useApiSend({
		fn: createPaymentMethodSession,
	});

	const updatePaymentMethod = async function () {
		const data = await mutateAsync();

		if (data?.url) window.location.href = data.url;
		else
			errorToast(i18n.t("payments:toast.cardFormFailed"));
	};

	return { updatePaymentMethod, isPending };
}
